import { Box, Page, Tabs } from '@shopify/polaris';
import { useSearchParams } from 'react-router';
import { reportDefinitions } from './reportDefinitions';

const tabs = reportDefinitions.map(({ id, label }) => ({ id, content: label }));

export default function Reports() {
    const [searchParams, setSearchParams] = useSearchParams();
    const selectedIndex = Math.max(
        0,
        reportDefinitions.findIndex(({ id }) => id === searchParams.get('report'))
    );
    const selectedReport = reportDefinitions[selectedIndex];
    const ReportComponent = selectedReport.component;

    const selectReport = (index) => {
        const nextParams = new URLSearchParams(searchParams);
        nextParams.set('report', reportDefinitions[index].id);
        setSearchParams(nextParams);
    };

    return (
        <Page title="Reports Dashboard" fullWidth>
            <Tabs tabs={tabs} selected={selectedIndex} onSelect={selectReport}>
                <Box paddingBlockStart="400">
                    <ReportComponent key={selectedReport.id} />
                </Box>
            </Tabs>
        </Page>
    );
}
